// Aspectcorrect
function ScaleImage(srcwidth, srcheight, targetwidth, targetheight, fLetterBox) {

    var result = { width: 0, height: 0, fScaleToTargetWidth: true };

    if ((srcwidth <= 0) || (srcheight <= 0) || (targetwidth <= 0) || (targetheight <= 0)) {
        return result;
    }

    // scale to the target width
    var scaleX1 = targetwidth;
    var scaleY1 = (srcheight * targetwidth) / srcwidth;

    // scale to the target height
    var scaleX2 = (srcwidth * targetheight) / srcheight;
    var scaleY2 = targetheight;

    // now figure out which one we should use
    var fScaleOnWidth = (scaleX2 > targetwidth);
    if (fScaleOnWidth) {
        fScaleOnWidth = fLetterBox;
    }
    else {
        fScaleOnWidth = !fLetterBox;
    }

    if (fScaleOnWidth) {
        result.width = Math.floor(scaleX1);
        result.height = Math.floor(scaleY1);
        result.fScaleToTargetWidth = true;
    }
    else {
        result.width = Math.floor(scaleX2);
        result.height = Math.floor(scaleY2);
        result.fScaleToTargetWidth = false;
    }
    result.targetleft = Math.floor((targetwidth - result.width) / 2);
    result.targettop = Math.floor((targetheight - result.height) / 2);

    return result;

}


// Thumbnail crop
jQuery(window).load(function(){
  	jQuery.each(jQuery('img.thumb-loader'), function(index, img){
   	 	OnImageLoad(jQuery(img));
  	});
});

function OnImageLoad(img) {
    // what's the size of this image and it's parent
    var w = img.width();
    var h = img.height();
    var tw = img.parent().parent().parent().width();
    var th = img.parent().parent().parent().height();

	//if(w == 0) return;
    // compute the new size and offsets
    var result = ScaleImage(w, h, tw, th, false);

    // adjust the image coordinates and size
    img.attr('width', result.width);
    img.attr('height', result.height);
    img.css("left", result.targetleft);
    img.css("top", result.targettop);
    img.css('opacity', 1);
}


function resizeImagesOnResize() {
  jQuery('img.thumb-loader').each( function($) {
    if ( jQuery(this).is(':visible') ) {
      var img = jQuery(this);
          // what's the size of this image and it's parent
      var w = img.width();
      var h = img.height();
      var tw = img.parent().parent().parent().width();
      var th = img.parent().parent().parent().height();

      // compute the new size and offsets
      var result = ScaleImage(w, h, tw, th, false);

      // adjust the image coordinates and size
      img.css('width', result.width);
      img.css('height', result.height);
      img.css("left", result.targetleft);
      img.css("top", result.targettop);
    }
  });
};

var resizeTimer;
jQuery(window).resize(function($) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(resizeImagesOnResize, 10);
});
